import type { ListingStage } from '@/api/v4/project-listings.api';
import { getSpotlightStagePillKeyForListingStage } from '@/features/listing-stage/helpers/get-spotlight-stage-pill-key-for-listing-stage';

import type { StagePillKey } from '../stage-pills/spotlight-stage-pill.types';

export const DEFAULT_STAGE_FILTERS: StagePillKey[] = [
  'investment',
  'deal',
  'pilot',
  'editorsChoice',
];

export const DEFAULT_LISTING_STAGE_FILTERS = DEFAULT_STAGE_FILTERS.filter(
  stageFilter => stageFilter !== 'editorsChoice',
);

export const getSelectedListingStageIds = (
  selectedStageFilters: StagePillKey[],
  listingStages: ListingStage[],
): string[] => {
  const hasDeal = selectedStageFilters.includes('deal');
  const hasInvestment = selectedStageFilters.includes('investment');
  const hasPilot = selectedStageFilters.includes('pilot');

  if (!hasDeal && !hasInvestment && !hasPilot) {
    return [];
  }

  const selectedStageIds = new Set<string>();

  for (const stage of listingStages) {
    const pillKey = getSpotlightStagePillKeyForListingStage(stage);

    if (!pillKey) {
      continue;
    }

    if (
      (hasDeal && pillKey === 'deal') ||
      (hasInvestment && pillKey === 'investment') ||
      (hasPilot && pillKey === 'pilot')
    ) {
      selectedStageIds.add(stage.id);
    }
  }

  return [...selectedStageIds];
};
